export function createActionTypes(fieldName) {
  const allCapName = fieldName.toUpperCase();
  return {
    setValuesForKeys: `${allCapName}_SET_VALUES_FOR_KEYS`
  };
}
